/**
 * PANEL QURILMASI (SATA ilovasi) — maktab FACE ID sahifasi, superadmin "Qurilmalar" sahifasi va
 * login uchun umumiy turlar va yordamchilar. Backend: `routes/qurilma.ts`, `lib/qurilma.ts`
 * (spec docs/superpowers/specs/2026-10-15-panel-faqat-ilova-design.md).
 */
export type QurilmaHolat = 'KUTILMOQDA' | 'TASDIQLANGAN' | 'RAD_ETILGAN' | 'BLOKLANGAN';
export type QurilmaAmal = 'tasdiqlash' | 'rad-etish' | 'bloklash' | 'blokdan-chiqarish';

export interface Qurilma {
  id: string;
  nom: string;
  ip: string | null;
  oxirgiIp: string | null;
  oxirgiFaollik: string | null;
  yaratilgan: string;
  holat: QurilmaHolat;
  holatAt: string | null;
  /** Qurilma kaliti bor (kalitning o'zi hech qachon qaytmaydi). false — ilova qayta ulanishi kerak. */
  kalitBor: boolean;
  /** So'rov yuborgan (shu) kompyuter — faqat maktab ro'yxatida. */
  joriy?: boolean;
  terminal: { name: string };
  /** Faqat superadmin ro'yxatida. */
  tenant?: { id: string; name: string } | null;
}

/** Panel sessiyasi (`X-Qurilma`) — `/ilova` sahifasi yozadi, `services/api.ts` yuboradi. */
export const QURILMA_SESSIYA = 'sata_qurilma';

export const HOLAT_RANG: Record<QurilmaHolat, string> = {
  KUTILMOQDA: 'yellow',
  TASDIQLANGAN: 'teal',
  RAD_ETILGAN: 'gray',
  BLOKLANGAN: 'red',
};

/** Kutilayotganlar tepada, keyin yangi ulanganlar. */
export function qurilmaTartibi(a: Qurilma, b: Qurilma): number {
  const k = Number(b.holat === 'KUTILMOQDA') - Number(a.holat === 'KUTILMOQDA');
  return k || b.yaratilgan.localeCompare(a.yaratilgan);
}

/** Holat va huquqqa qarab ko'rinadigan amallar (o'tishlar jadvali — backend `holatniOzgartir`). */
export function qurilmaAmallari(holat: QurilmaHolat, huquq: { tasdiqlay: boolean; bloklay: boolean }): QurilmaAmal[] {
  const a: QurilmaAmal[] = [];
  if (huquq.tasdiqlay && (holat === 'KUTILMOQDA' || holat === 'RAD_ETILGAN')) a.push('tasdiqlash');
  if (huquq.tasdiqlay && holat === 'KUTILMOQDA') a.push('rad-etish');
  if (huquq.bloklay && holat === 'TASDIQLANGAN') a.push('bloklash');
  if (huquq.bloklay && holat === 'BLOKLANGAN') a.push('blokdan-chiqarish');
  return a;
}

/** Server javobidagi qurilma bayrog'i → i18n kaliti (null — bayroq yo'q, server matni ko'rsatiladi). */
export function qurilmaXatoKaliti(d?: Record<string, unknown> | null): string | null {
  if (!d) return null;
  if (d.ilovaKerak) return 'qurilma.xIlovaKerak';
  if (d.qurilmaBloklangan) return 'qurilma.xBloklangan';
  if (d.qurilmaKutilmoqda) return 'qurilma.xKutilmoqda';
  if (d.qurilmaRadEtilgan) return 'qurilma.xRadEtilgan';
  if (d.boshqaMaktabQurilmasi) return 'qurilma.xBoshqaMaktab';
  if (d.qurilmaSessiyaEskirgan) return 'qurilma.xSessiya';
  if (d.birinchiQurilmaSuperadmin) return 'qurilma.xBirinchi';
  if (d.kalitKutilmoqda) return 'qurilma.xKalitKutilmoqda';
  if (d.kodEskirgan) return 'qurilma.havolaEskirgan';
  if (d.qurilmaOzgardi) return 'qurilma.xOzgardi';
  return null;
}
